import { render, staticRenderFns } from "./ApproveTravelByDep.vue?vue&type=template&id=4502a454&scoped=true"
import script from "./ApproveTravelByDep.vue?vue&type=script&lang=js"
export * from "./ApproveTravelByDep.vue?vue&type=script&lang=js"
import style0 from "./ApproveTravelByDep.vue?vue&type=style&index=0&id=4502a454&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4502a454",
  null
  
)

export default component.exports